import React from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { Switch, Route } from "wouter";
import { queryClient } from "./lib/queryClient";
import { Toaster } from "./components/ui/toaster";
import AppShell from "./components/app-shell";
import ProtectedRoute from "./components/protected-route";

// Pages
import Dashboard from "./pages/dashboard";
import CCTV from "./pages/cctv";
import Visits from "./pages/visits";
import Operations from "./pages/operations";
import KanbanBoard from "./pages/kanban-board";
import Sessions from "./pages/sessions";
import Tickets from "./pages/tickets";
import Audit from "./pages/audit";
import VisitorCompliance from "./pages/visitor-compliance";
import Allowance from "./pages/allowance";
import Bookings from "./pages/bookings";
import PlanVsActual from "./pages/plan-vs-actual";
import BusinessPartners from "./pages/business-partners";
import Orders from "./pages/orders";
import Settings from "./pages/settings";
import ScheduledReports from "./pages/scheduled-reports";
import Suppliers from "./pages/suppliers";
import Clients from "./pages/clients";
import Transporters from "./pages/transporters";
import Transportation from "./pages/transportation";
import TransportationDetail from "./pages/transportation-detail";
import StockManagement from "./pages/stock-management";
import StockAreaDetails from "./pages/stock-area-details";
import Overview from "./pages/overview";
import Login from "./pages/login";
import Register from "./pages/register";
import AdminPanel from "./pages/admin-panel";
import NotFound from "./pages/not-found";
import InternalWeighbridge from "./pages/internal-weighbridge";
import ExternalWeighbridge from "./pages/external-weighbridge";

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Switch>
        {/* Auth pages without AppShell - Public routes */}
        <Route path="/login" component={Login} />
        
        {/* Main app pages with AppShell - Protected routes */}
        <Route>
          <ProtectedRoute>
            <AppShell>
              <Switch>
                <Route path="/" component={Dashboard} />
                <Route path="/admin" component={AdminPanel} />
                <Route path="/overview" component={Dashboard} />
                <Route path="/cctv" component={CCTV} />
                <Route path="/visits" component={Visits} />
                <Route path="/operations" component={Operations} />
                <Route path="/kanban-board" component={KanbanBoard} />
                <Route path="/sessions" component={Sessions} />
                <Route path="/tickets" component={Tickets} />
                <Route path="/internal-weighbridge" component={InternalWeighbridge} />
                <Route path="/external-weighbridge" component={ExternalWeighbridge} />
                <Route path="/audit" component={Audit} />
                <Route path="/visitor-compliance" component={VisitorCompliance} />
                <Route path="/allowance" component={Allowance} />
                <Route path="/bookings" component={Bookings} />
                <Route path="/plan-vs-actual" component={PlanVsActual} />
                <Route path="/business-partners" component={BusinessPartners} />
                <Route path="/orders" component={Orders} />
                <Route path="/settings" component={Settings} />
                <Route path="/scheduled-reports" component={ScheduledReports} />
                <Route path="/suppliers" component={Suppliers} />
                <Route path="/suppliers/:id" component={Suppliers} />
                <Route path="/clients" component={Clients} />
                <Route path="/clients/:id" component={Clients} />
                <Route path="/transporters" component={Transporters} />
                <Route path="/transporters/:id" component={Transporters} />
                <Route path="/transportation" component={Transportation} />
                <Route path="/transportation/:id" component={TransportationDetail} />
                <Route path="/stock-management" component={StockManagement} />
                <Route path="/stock-management/areas/:id" component={StockAreaDetails} />
                <Route path="/overview" component={Overview} />
                <Route component={NotFound} />
              </Switch>
            </AppShell>
          </ProtectedRoute>
        </Route>
      </Switch>
      <Toaster />
    </QueryClientProvider>
  );
}

export default App;